// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"94aca4a1","455":"456e7a52","977":"03479ac8"}[chunkId] + ".chunk.js";
};